import { render } from "./CometChatImageViewer.vue?vue&type=template&id=52d7212c"
import script from "./CometChatImageViewer.vue?vue&type=script&lang=js"
export * from "./CometChatImageViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__